'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'burger';
var width = 512;
var height = 512;
var aliases = ["hamburger"];
var unicode = 'f805';
var svgPathData = 'M32.3 192c.9-13.8 3.9-27.4 10.5-39.5 2.8-5.1 6.2-10.9 10.2-17 4.5-6.9 9.9-14.2 16.2-21.7 21.7-25.7 54.2-53.1 101.5-68.8 24.4-8.1 52.6-13.1 85.3-13.1 130.7 0 190.9 79.5 213.2 120.5 6.6 12.2 9.6 25.7 10.5 39.5 .2 3.3 .3 6.6 .3 10l0 38-48 0 0-38c0-12.9-2-21.1-5-26.6-17.5-32.1-64.3-95.4-171-95.4S102.5 143.3 85 175.4c-.4 .7-.7 1.4-1.1 2.2-2.4 5.4-3.9 13.1-3.9 24.4l0 38-48 0 0-38c0-3.3 .1-6.7 .3-10zm6.3 240c-4.3-9.8-6.7-20.6-6.7-32l0-16 48 0 0 16c0 17.7 14.3 32 32 32l288 0c17.7 0 32-14.3 32-32l0-16 48 0 0 16c0 11.4-2.4 22.2-6.7 32-12.3 28.3-40.5 48-73.3 48l-288 0c-32.8 0-61-19.7-73.3-48zM0 312c0-13.3 10.7-24 24-24l464 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 336c-13.3 0-24-10.7-24-24zM256 104a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM136 160a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm216-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBurger = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;